import { isNil, pathSatisfies, either, equals, complement } from 'ramda'
import { safeIncludes } from 'utils/functional'
import { isUndefined } from 'utils/types'

import {
  COMPLEX,
  TIMER,
  CAN_INPUT,
  PWM,
  SIMPLE,
  DIGITAL_INPUT,
  ANALOG_INPUT,
  NATIVE_INPUT,
} from 'utils/constants'
import { INTERNAL } from 'constants/featureTypes'

// queries
export const requiredCan = (queryType, description) =>
  queryType === CAN_INPUT && description === null

export const isDefinedCondition = (condition) => {
  const {
    signal: querySignal,
    floatingCircuit,
    queryType,
    numberOfBits,
    startBit,
    canId,
    refQueryUri,
  } = condition

  const validCan =
    queryType === CAN_INPUT &&
    !isNil(numberOfBits) &&
    !isNil(startBit) &&
    !isNil(canId)

  const validReference = queryType === 'referenced' && !isNil(refQueryUri)

  return (
    !isNil(querySignal) || !isNil(floatingCircuit) || validCan || validReference
  )
}

export const isCondition = (queryType) =>
  queryType !== COMPLEX && queryType !== TIMER

export const isOrphan = (uri, context) =>
  pathSatisfies(
    safeIncludes(uri),
    ['options', 'context', 'orphanUris'],
    context
  )

// fetaure meta
export const isInternal = either(isUndefined, equals(INTERNAL))

// outputs
const notEquals = complement(equals)
export const isPWM = either(isUndefined, equals(PWM))

/** pwmMode checks */
export const isVariableDutyCycle = either(isUndefined, equals(2))
export const isVariableFrequency = either(isUndefined, equals(3))

export const isNotVariableDutyCycle = either(isUndefined, notEquals(2))
export const isNotVariableFrequency = either(isUndefined, notEquals(3))

// signals
const SINGLE_CONDITIONS = [DIGITAL_INPUT, ANALOG_INPUT, NATIVE_INPUT]

export const isSingleSimpleCondition = (parentQueryUri, queryType, subType) =>
  parentQueryUri === '' &&
  queryType === SIMPLE &&
  SINGLE_CONDITIONS.includes(subType)
